module.exports = __webpack_public_path__ + "static/media/codebot_head_blink.d08634c2.svg";